import { Injectable, Type } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  public readonly _isOpen = new BehaviorSubject<boolean>(false);
  isOpen$ = this._isOpen.asObservable();

  private readonly _title = new BehaviorSubject<string>('');
  title$ = this._title.asObservable();

  private readonly _inputs = new BehaviorSubject<Record<string, unknown>>({});
  inputs$ = this._inputs.asObservable();

  public readonly component = new BehaviorSubject<Type<unknown> | null>(null);
  component$ = this.component.asObservable();

  private readonly _size = new BehaviorSubject<
    'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '7xl'
  >('2xl');
  size$ = this._size.asObservable();

  openWithComponent<T>(
    component: Type<T>,
    title: string,
    size: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '7xl',
    inputs: Record<string, unknown> = {},
  ) {
    if (
      this.component.getValue() !== component ||
      this._title.getValue() !== title ||
      JSON.stringify(this._inputs.getValue()) !== JSON.stringify(inputs)
    ) {
      this._title.next(title);
      this._size.next(size);
      this._inputs.next(inputs);
      this.component.next(component);
      this._isOpen.next(true);
    }
  }

  changeTitle(title: string) {
    this._title.next(title);
  }

  close() {
    this._isOpen.next(false);
    this._title.next('');
    this._size.next('2xl');
    this.component.next(null);
    this._inputs.next({});
  }
}
